import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import {  ExtraSmallButton, PrimaryButton } from "../../../../Constant";
import {  EXTRA_SMALL_BUTTONS_LIST, EXTRA_SMALL_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const ExtraSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={ExtraSmallButton} span={EXTRA_SMALL_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="xs" color="primary" id="Tooltip-22">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-22" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-primary btn-xs</ToolTip>
          {EXTRA_SMALL_BUTTONS_LIST.map((data, index) => (
            <CommonButton key={index} item={data} size="xs" />
          ))}
        </CardBody>
      </Card>
    );
};

export default ExtraSmallButtons;
